import { render, staticRenderFns } from "./SearchCardCollection.vue?vue&type=template&id=35ad4138&scoped=true&"
import script from "./SearchCardCollection.vue?vue&type=script&lang=js&"
export * from "./SearchCardCollection.vue?vue&type=script&lang=js&"
import style0 from "./SearchCardCollection.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SearchCardCollection.vue?vue&type=style&index=1&id=35ad4138&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ad4138",
  null
  
)

export default component.exports